<section>
  <h1>Create <span class="emphasis">NOC</span> Ticket</h1>
  @if (nocFormGroup) {
    <form
      [formGroup]="nocFormGroup"
      [ngClass]="{ 'form-submit-attempt': formSubmitAttempted }"
      autocomplete="off"
    >
      <h2>General Information</h2>
      <app-primary-reporter
        [formRef]="nocFormGroup"
        [reporters]="primaryReporters"
        (usersLoaded)="usersLoaded()"
      >
      </app-primary-reporter>

      <app-service-location
        [formRef]="nocFormGroup"
        [services]="services"
        [selectedServiceId]="selectedServiceId"
        [inlineErrors]="inlineErrors"
        [validateForNoc]="true"
        (servicesLoaded)="servicesLoaded()"
      >
      </app-service-location>

      <h2>Issue Summary</h2>
      <div class="question">What service area do you need support with?</div>
      <mat-form-field>
        <mat-label>Please select</mat-label>
        <mat-select
          formControlName="serviceArea"
          (selectionChange)="changeServiceArea()"
        >
          <mat-option value="My Service Is Down">My Service Is Down</mat-option>
          <mat-option value="My Service is Degraded or Intermittent"
            >My Service is Degraded or Intermittent</mat-option
          >
          <mat-option
            value="I would like to make a change to my existing service"
            >I would like to make a change to my existing service</mat-option
          >
          <mat-option value="I have a question or request for my service"
            >I have a question or request for my service</mat-option
          >
        </mat-select>
      </mat-form-field>
      @if (inlineErrors.serviceArea) {
        <div class="form-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">{{ inlineErrors.serviceArea }}</div>
        </div>
      }

      @if (
        nocFormGroup.value.serviceArea === 'My Service Is Down' ||
        nocFormGroup.value.serviceArea ===
          'My Service is Degraded or Intermittent'
      ) {
        <div class="question">Has power to the equipment been verified?</div>
        <mat-form-field>
          <mat-label>Please select</mat-label>
          <mat-select
            formControlName="isPowerOn"
            (selectionChange)="canSubmit()"
          >
            <mat-option value="Yes">Yes</mat-option>
            <mat-option value="No">No</mat-option>
          </mat-select>
        </mat-form-field>
        @if (inlineErrors.isPowerOn) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">{{ inlineErrors.isPowerOn }}</div>
          </div>
        }

        <div class="question">
          Can Comcast Business perform intrusive tests?
        </div>
        <mat-form-field>
          <mat-label>Please select</mat-label>
          <mat-select
            formControlName="canPerformIntrusiveTests"
            (selectionChange)="changeIntrusiveTesting()"
          >
            <mat-option value="No">No</mat-option>
            <mat-option value="Yes (Any Time)">Yes (Any Time)</mat-option>
            <mat-option value="Yes (Custom)">Yes (Custom)</mat-option>
          </mat-select>
        </mat-form-field>
        @if (inlineErrors.canPerformIntrusiveTests) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">
              {{ inlineErrors.canPerformIntrusiveTests }}
            </div>
          </div>
        }
        @if (nocFormGroup.value.canPerformIntrusiveTests === 'Yes (Custom)') {
          <div class="question">From:</div>
          <mat-form-field>
            <input
              matInput
              type="time"
              formControlName="testHoursStart"
              (selectionChange)="canSubmit()"
            />
          </mat-form-field>
          <div class="question">
            @if (inlineErrors.testHoursStart) {
              <div class="form-error">
                <div class="custom-icon inline_error"></div>
                <div class="error-message">
                  {{ inlineErrors.testHoursStart }}
                </div>
              </div>
            }
            To:
          </div>
          <mat-form-field>
            <input
              matInput
              type="time"
              formControlName="testHoursEnd"
              (selectionChange)="canSubmit()"
            />
          </mat-form-field>
          @if (inlineErrors.testHoursEnd) {
            <div class="form-error">
              <div class="custom-icon inline_error"></div>
              <div class="error-message">{{ inlineErrors.testHoursEnd }}</div>
            </div>
          }

          <mat-form-field>
            <mat-label>Select Days</mat-label>
            <mat-select
              formControlName="testDays"
              multiple
              (selectionChange)="canSubmit()"
            >
              <mat-option value="Sunday">Sunday</mat-option>
              <mat-option value="Monday">Monday</mat-option>
              <mat-option value="Tuesday">Tuesday</mat-option>
              <mat-option value="Wednesday">Wednesday</mat-option>
              <mat-option value="Thursday">Thursday</mat-option>
              <mat-option value="Friday">Friday</mat-option>
              <mat-option value="Saturday">Saturday</mat-option>
            </mat-select>
          </mat-form-field>
          @if (inlineErrors.canPerformIntrusiveTests) {
            <div class="form-error">
              <div class="custom-icon inline_error"></div>
              <div class="error-message">
                {{ inlineErrors.canPerformIntrusiveTests }}
              </div>
            </div>
          }
        }

        <div class="question">Site access hours</div>
        <mat-form-field>
          <input
            matInput
            type="text"
            formControlName="accessHours"
            (selectionChange)="canSubmit()"
          />
        </mat-form-field>
        @if (inlineErrors.accessHours) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">{{ inlineErrors.accessHours }}</div>
          </div>
        }
        <div class="question">Site Contact First Name</div>
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input
            matInput
            type="text"
            formControlName="siteLocalFirst"
            (selectionChange)="canSubmit()"
          />
        </mat-form-field>
        @if (inlineErrors.siteLocalFirst) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">{{ inlineErrors.siteLocalFirst }}</div>
          </div>
        }
        <div class="question">Site Contact Last Name</div>
        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input
            matInput
            type="text"
            formControlName="siteLocalLast"
            (selectionChange)="canSubmit()"
          />
        </mat-form-field>
        @if (inlineErrors.siteLocalLast) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">{{ inlineErrors.siteLocalLast }}</div>
          </div>
        }
        <div class="question">Site Contact Email</div>
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="siteLocalEmail"
            (selectionChange)="canSubmit()"
            [ngClass]="{
              'orange-highlight': errorMessage?.includes('valid email address'),
            }"
          />
        </mat-form-field>
        @if (inlineErrors.siteLocalEmail) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">{{ inlineErrors.siteLocalEmail }}</div>
          </div>
        }
        <div class="question">Site Contact Phone</div>
        <mat-form-field>
          <mat-label>Phone</mat-label>
          <input
            matInput
            type="phone"
            formControlName="siteLocalPhone"
            (selectionChange)="canSubmit()"
          />
        </mat-form-field>
        @if (inlineErrors.siteLocalPhone) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">{{ inlineErrors.siteLocalPhone }}</div>
          </div>
        }
      }
      <div class="question">
        Please describe the issue(s) you're experiencing.
      </div>
      <mat-form-field class="custom-textarea">
        <mat-label>Tell us about the issue...</mat-label>
        <textarea matInput formControlName="description" rows="5"></textarea>
      </mat-form-field>

      @if (inlineErrors.description) {
        <div class="form-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">{{ inlineErrors.description }}</div>
        </div>
      }
      @if (!hideCustomerTicketNumber) {
        <div class="question">Customer Ticket Number</div>
        <mat-form-field>
          <input matInput type="text" formControlName="customerTicketNumber" />
        </mat-form-field>
      }
      @if (isSubmitting) {
        <div class="loading-indicator">
          <mat-spinner [diameter]="25"></mat-spinner>
        </div>
      } @else if (submissionError) {
        <div [ngClass]="errorMessage ? 'server-error' : 'form-error'">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">
            @if (errorMessage) {
              {{ errorMessage }}
            } @else {
              <b>Error: </b> Unable to submit the ticket. Please try again!
            }
          </div>
        </div>
      }

      <div class="mt-6 flex justify-end">
        <button
          class="primary-button m-0"
          (click)="submitTicket()"
          [disabled]="loadingServices || loadingUsers || isSubmitting"
        >
          <span>Submit ticket</span>
        </button>
      </div>
    </form>
  }
</section>
